import axios from "axios"
import Config from "../config"


const createHostPage = (data: any) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/create-host-page`, data)
}

const addonRecharge = (data: any, isRecurring: boolean) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/addon-recharge?recurring=${isRecurring}`, data)
}

const cancelSubscription = (subscriptionIds: string[]) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/cancel-subscription`, subscriptionIds);
}

const cancelItem = (itemId: string, phonePlanIDs: string[], phoneId: string, subscriptionId: string, quantity: number) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/cancel-item`, { phonePlanIDs, quantity, itemId, phoneId, subscriptionId });
}

const modifyHostPage = (data: any) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/create-host-page-for-seats`, data)
}

const getCardDeatils = (data) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/payment-method`, data)
}

const getAllCardDeatils = (data) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/list-payment-sources`, data)
}

const editPaymentCardDeatils = (data) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/edit-card`, data)
}

const creatPaymentCard = (data) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/create-card`, data)
}

const deletePaymentCard = (data) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/delete-payment-source`, data)
}

const editPaymentCard = (data) => {
    return axios.post(`${Config.CHARGEBEE_INTEGRATION_API_URL}/edit-payment-source-host-page`, data)
}

export default {
    createHostPage,
    addonRecharge,
    cancelSubscription,
    cancelItem,
    modifyHostPage,
    getCardDeatils,
    getAllCardDeatils,
    editPaymentCardDeatils,
    creatPaymentCard,
    deletePaymentCard,
    editPaymentCard,
};